module.exports = __WEBPACK_EXTERNAL_MODULE_vue_class_component__;